// extracted by mini-css-extract-plugin
module.exports = {"root":"_2d8439","text":"_2d0cce","screenshotImage":"_cab6d5","card":"_f48034","freeTrialTag":"_cd7e5f"};